<template>
    <div v-if="formInput.visibility" class="position-relative row mb-3">
        <label class="form-label col-sm-2 col-form-label" :for="formInput.name">{{formInput.label}}</label>
        <div class="col-sm-10">
            <pv-input-number
                    :id="formInput.name"
                    style="width: 100%"
                    :inputClass="inputClass"
                    :class="{'is-invalid': formInput.error, 'is-valid': formInput.validated}"
                    :placeholder="formInput.placeholder"
                    :disabled="formInput.disabled"
                    v-tooltip.top="formInput.tooltip"
                    mode="decimal"
                    :minFractionDigits="formInput.minFractionDigits"
                    :maxFractionDigits="formInput.maxFractionDigits"
                    :locale="formInput.locale"
                    :suffix="formInput.suffix"
                    :prefix="formInput.prefix"
                    :min="formInput.min"
                    :max="formInput.max"
                    :useGrouping="formInput.grouping"
                    v-model="value"/>
            <div v-if="formInput.error" class="invalid-feedback">
                <span v-if="formInput.errorCustom">{{formInput.customMessage}}</span>
                <span v-if="formInput.errorRequired">{{formInput.requiredMessage}}</span>
            </div>
            <small class="form-text text-muted" v-if="formInput.info">
                {{formInput.info}}
            </small>
        </div>
    </div>
</template>

<script>

    import InputNumber from 'primevue/inputnumber';
    import Tooltip from 'primevue/tooltip';


    export default {
        props: ['formInput'],
        emits: ['changeValue'],
        components: {
            'pv-input-number': InputNumber,
        },
        directives: {
            'tooltip': Tooltip
        },
        computed: {
            inputClass() {
                let className = 'form-control';
                if (this.formInput.error) {
                    className += ' is-invalid';
                }
                if (this.formInput.validated) {
                    className += ' is-valid';
                }
                return className;
            }
        },
        data() {
            return {
                value: ''
            }
        },
        created() {
            this.value = this.formInput.value;
        },
        watch: {
            value(newValue) {
                if (this.formInput) {
                    this.$emit('changeValue', {name: this.formInput.name, value: newValue})
                }
            },
            formInput: {
                handler() {
                    this.value = this.formInput.value;
                },
                deep: true
            }

        }
    }
</script>